export class MeetingDetails{
    public meetingDate: Date;
    public claimant:string;
    public respondent:string;
    public officeCaseNumber: string;
    public webexLink:string;
    public meetingNumber:string;
    public password:string;
    // public sessionNumber:string;
    public meetingHostKey:string;
    public meetingRecordingLink1:string;
    public meetingRecordingLink2:string;
    public meetingRecordingLink3:string;
    public meetingRecordingLink4:string;
    public status: string;
    public createdBy: string;
    public email: string;
    public isSelected:boolean;
  }

  export enum StatusCase {
       PENDING_APPROVAL = 'PENDING_APPROVAL',
       ACTIVE = 'ACTIVE',
       CLOSED = 'CLOSED',
       REJECTED = 'REJECTED'
  }



  export class CaseData {
    id: number;
    code: string;
    status: string;
    dateReceived: string;
    office: string;
    officeCaseNumber: string | null;
    nameClaimant: string;
    addressClaimant: string | null;
    telephoneClaimant: string | null;
    countryClaimant: string;
    emailClaimant: string;
    nameClaimantRepBy: string | null;
    addressClaimantRepBy: string | null;
    telephoneClaimantRepBy: string | null;
    countryClaimantRepBy: string | null;
    emailClaimantRepBy: string | null;
    nameRespondent: string;
    addressRespondent: string | null;
    telephoneRespondent: string | null;
    countryRespondent: string;
    emailRespondent: string;
    nameRespondentRepBy: string | null;
    addressRespondentRepBy: string | null;
    telephoneRespondentRepBy: string | null;
    countryRespondentRepBy: string | null;
    emailRespondentRepBy: string | null;
    disputeDescription: string;
    signature: string;
    language: string;
    additionalParties: any | null; // Can be a more specific interface if known
    notes: string | null;
    mediationAgreement: any | null; // Can be a more specific interface if known
    proofOfPayment: any | null; // Can be a more specific interface if known
    otherDocuments: any | null; // Can be a more specific interface if known
    claimDocuments: any | null; // Can be a more specific interface if known
    deletedAt: string | null;
  }

  
  
  